import {Helper} from "../../core/utils/Helper";
import {TheRave} from "../TheRave";


export class TheRaveHelper extends Helper {

    public static getBuyFeaturePrice(): number {
        let betLevel = TheRave.apiPlugin.freeBets.hasFreeBets() ? TheRave.apiPlugin.freeBets.getBet() : TheRave.apiPlugin.betLevel.getLevel();
        let price: number = Number(TheRave.model.gameData?.playedBetValue) || parseFloat(betLevel);
        if (TheRave.model.data.wasFeatureBuy) {
            for (let index = 0; index < TheRave.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheRave.model.initData.featureBuyTimesBetValue[index].name === TheRave.model.buyFeatureName) {
                    price *= TheRave.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    public static isWinBelowStake(): boolean {
        return TheRave.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (Number(TheRave.model.data.accumulatedRoundWin) <= this.getBuyFeaturePrice());
    }

    public static spineAnimationHelper(spine:PIXI.spine.Spine, name:string = "NO NAME SPECED", noLog:boolean = true): number [] {
        const durations:number [] = [];
        const animations: any = spine.skeleton.data.animations;
        const animationNames: string [] = [];
        animations.forEach((obj: any) => {
            animationNames.push(obj.name);
            durations.push(obj.duration);
            //debugger;
            //if(!noLog)
            //console.log("SPINE SKELETON DATA: " + name, spine.skeleton.data.animations);
            //endTimes.push(spine.state.tracks[index].endTime);
        });

        if(!noLog) {
            //console.log("SPINE ANIMATIONS FOR, " + name, durations);
        }

        return durations;
    }


}
